import {Controller} from "@hotwired/stimulus"
import {Dropdown} from "bootstrap"

export default class extends Controller {
    connect() {
        const form = this.element;
        const url = new URL(window.location.href);

        for (const element of form.elements) {
            if (!element.name) continue;

            const values = url.searchParams.getAll(element.name);

            if (element.type === "checkbox") {
                element.checked = values.includes(element.value);
            } else if (element.tagName === "SELECT" && element.multiple) {
                Array.from(element.options).forEach(option => {
                    option.selected = values.includes(option.value);
                });
            } else {
                const value = url.searchParams.get(element.name);
                if (value !== null) {
                    element.value = value;
                }
            }
        }
    }

    submit(e) {
        e.preventDefault();

        const form = this.element;
        const formData = new FormData(form);
        const url = new URL(window.location.href);

        // удалить из URL все параметры, которые относятся к этой форме
        const formKeys = [...new Set(Array.from(formData.keys()))];

        // важно: если чекбоксы все сняты, их ключа вообще не будет в formData
        // поэтому добавим ключи и из элементов формы
        for (const element of form.elements) {
            if (element.name && !formKeys.includes(element.name)) {
                formKeys.push(element.name);
            }
        }

        formKeys.forEach(key => url.searchParams.delete(key));

        // добавить текущие значения заново
        for (const [key, value] of formData.entries()) {
            if (value !== "") {
                url.searchParams.append(key, value);
            }
        }

        const dropdownEl = e.target.closest(".dropdown");
        if (dropdownEl) {
            Dropdown.getOrCreateInstance(dropdownEl).hide();
        }

        Turbo.visit(url, {action: "advance"});
    }
    clearSelect(e) {
        const targetId = e.currentTarget.dataset.targetId
        const element = document.getElementById(targetId)
        if (!element) return

        element.value = ""
        this.element.requestSubmit()
    }

    clearCheckboxes(e) {
        const name = e.currentTarget.dataset.checkboxName

        this.element.querySelectorAll(`input[type="checkbox"][name="${name}"]`).forEach((el) => {
            el.checked = false
        })

        this.element.requestSubmit()
    }

    setSort(e) {
        const hiddenId = e.currentTarget.dataset.targetId
        const value = e.currentTarget.dataset.sortValue
        const input = document.getElementById(hiddenId)
        if (!input) return

        input.value = input.value === value ? "" : value
        this.element.requestSubmit()
    }

    clearSort(e) {
        const hiddenId = e.currentTarget.dataset.targetId
        const input = document.getElementById(hiddenId)
        if (!input) return

        input.value = ""
        this.element.requestSubmit()
    }
    setValue(e) {
        const targetId = e.currentTarget.dataset.targetId
        const value = e.currentTarget.dataset.value
        const input = document.getElementById(targetId)
        if (!input) return

        input.value = input.value === value ? "" : value
        this.element.requestSubmit()
    }

    clearValue(e) {
        const targetId = e.currentTarget.dataset.targetId
        const input = document.getElementById(targetId)
        if (!input) return

        input.value = ""
        this.element.requestSubmit()
    }
    clearRange(e) {
        const fromId = e.currentTarget.dataset.targetFrom
        const toId = e.currentTarget.dataset.targetTo

        const from = document.getElementById(fromId)
        const to = document.getElementById(toId)

        if (from) from.value = ""
        if (to) to.value = ""

        this.element.requestSubmit()
    }
}